import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumeroDe1a100]'
})
export class NumeroDe1a100Directive {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const tecla = event.key;
    const input = this.el.nativeElement as HTMLInputElement;

    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

    if (allowedKeys.includes(tecla)) return;

    // Bloqueia tudo que não for número
    if (!/^[0-9]$/.test(tecla)) {
      event.preventDefault();
      return;
    }

    const valorAtual = input.value;
    const pos = input.selectionStart ?? valorAtual.length;

    const novoValor = valorAtual.slice(0, pos) + tecla + valorAtual.slice(pos);
    const numero = parseInt(novoValor, 10);

    if (isNaN(numero) || numero < 0 || numero > 101) {
      event.preventDefault();
      return;
    }

    // ✅ Impede o valor duplicado e insere manualmente
    event.preventDefault();
    input.value = String(numero);
    this.control?.control?.setValue(numero);
  }
}
